import styled from 'styled-components';
import LazyImage from '../../components/LazyImage';
import { FLEX_CENTER_CENTER } from '@/utils/styles';
import IconText from '../../components/IconText';

export const StoreDetailContainer = styled.div`
  background: #fff;
  box-shadow: 0px 1px 13px 3px #18181896;
  margin-bottom: 25px;
`;

export const PoweredByBanner = styled.div`
  background: #fff;
  box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.1);
  position: absolute;
  right: 0;
  bottom: calc(100% + 1rem);
  border-radius: 2px 0 0 2px;
`;

export const StoreImageContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  height: 200px;
  background: #fff;
  position: relative;
`;

export const StoreImage = styled(LazyImage)`
  width: 100%;
  height: 100%;
`;

export const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
`;

export const StoreName = styled.div`
  font-size: 1.5rem;
  color: #fff;
  font-weight: 500;
  width: 100%;
  padding: 0 1rem;
  text-align: center;
  line-height: 1.3;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
`;
export const ButtonSpacer = styled.div`
  width: 15px;
`;

export const StoreLocation = styled(IconText)`
  display: flex;
  justify-content: center;
  color: #fff;
  padding-top: 0.5rem;
`;

export const BottomContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  max-width: 100%;
`;

export const BottomButtonsContainer = styled.div`
  padding: 1rem 0.5rem;
  ${FLEX_CENTER_CENTER};
`;

export const FooterButtonText = styled.div`
  ${FLEX_CENTER_CENTER};
`;
